module.exports = __webpack_public_path__ + "static/media/faqBalance-en-vi.db67fb71.vtt";